module.exports = __webpack_public_path__ + "static/media/SM-1MTJ.62e6410d.png";